import { Route } from 'react-router-dom';
import PageTitle from '../components/PageTitle';
import DTEConfigurationPage from '../pages/Hacienda/DTEConfigurationPage';
import TaxpayerAuthenticationConfigPage from '../pages/Hacienda/TaxpayerAuthenticationConfigPage';
import TaxpayerCertificateUploadPage from '../pages/Hacienda/TaxpayerCertificateUploadPage';
import ProtectedRouteV2 from './ProtectedRouteV2';
import ContingencyEventHistoryPage from '../pages/Hacienda/ContingencyEventHistoryPage';
import DteSystemStatusPage from '../pages/Hacienda/DteSystemStatusPage';
import DteTestsProgressPage from '../pages/Hacienda/DteTestsProgressPage';
import DteTestRequirementPage from '../pages/Hacienda/DteTestRequirementPage';
import DteInvalidationErrorsPage from '../pages/Hacienda/DteInvalidationErrorsPage';

const dteRoutes = (
  <Route element={<ProtectedRouteV2 />}>
    {/* ✅ Parámetros DTE */}
    <Route
      path="/hacienda/dte-config"
      element={
        <>
          <PageTitle title="Parámetros DTE | POS System" />
          <DTEConfigurationPage />
        </>
      }
    />

    {/* ✅ Configuración del Contribuyente */}
    <Route
      path="/hacienda/taxpayer-config"
      element={
        <>
          <PageTitle title="Configuración del Contribuyente | POS System" />
          <TaxpayerAuthenticationConfigPage />
        </>
      }
    />

    <Route
      path="/hacienda/electronic-certificate-upload"
      element={
        <>
          <PageTitle title="Certificado Electrónico | POS System" />
          <TaxpayerCertificateUploadPage />
        </>
      }
    />

    <Route
      path="/hacienda/contingencies"
      element={
        <>
          <PageTitle title="Historial de Contingencias DTE | POS System" />
          <ContingencyEventHistoryPage />
        </>
      }
    />

    <Route
      path="/hacienda/dte-system-status"
      element={
        <>
          <PageTitle title="Estado del Sistema DTE | POS System" />
          <DteSystemStatusPage />
        </>
      }
    />

    <Route
      path="/hacienda/dte-tests-progress"
      element={
        <>
          <PageTitle title="Progreso de Pruebas MH | POS System" />
          <DteTestsProgressPage />
        </>
      }
    />

    <Route
      path="/hacienda/dte-test-requirements"
      element={
        <>
          <PageTitle title="Requisitos de Pruebas DTE | POS System" />
          <DteTestRequirementPage />
        </>
      }
    />

    <Route
      path="/hacienda/invalidation-errors"
      element={
        <>
          <PageTitle title="Errores de Invalidación DTE | POS System" />
          <DteInvalidationErrorsPage />
        </>
      }
    />
  </Route>
);

export default dteRoutes;
